import { OrganizationNotificationType } from 'ab-enums/organizationNotificationType.enum';

export const NOTIFICATION_TYPE = OrganizationNotificationType.DEACTIVATED_AND_REACTIVATED_USERS;
